import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader';
import { commonStyles } from '~/modules/covenants/CovenantsDataForm/commonStyles.ts';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import ButtonLoadingIcon from '~/modules/guarantees/form/shared/ButtonLoadingIcon.tsx';
import ApplicationHeader from '../../shared/components/ApplicationHeader.tsx';
import ApplicationPageFrame from '../../shared/components/ApplicationPageFrame.tsx';
import GuaranteesManagerApplicationSidePanelLayout from '../shared/SidePanel/GuaranteesManagerApplicationSidePanelLayout.tsx';
import { MANAGER_APPROVAL_LETTER_TEXT } from '../step4/constants.ts';
import ClientSignedApprovalLetterSection from './ClientSignedApprovalLetterSection.tsx';
import { useManagerApprovalLetterClientSignedPage } from './useManagerApprovalLetterClientSignedPage.ts';

const ManagerApprovalLetterClientSignedPage: React.FC = () => {
  const {
    effectiveApplicationId,
    handleCloseAlertModal,
    handleCloseAmAccessModal,
    handleCloseSuccessModal,
    handleOpenPdf,
    handleSubmitByAmManager,
    headerProps,
    isAmAccessDenied,
    isAmAccessLoading,
    isApplicationLoading,
    isDocumentLoading,
    isSubmitDisabled,
    isSubmittingByAmManager,
    modalAlert,
    modalSuccess,
    pdfUrl,
    redirectPath,
    showGuaranteesRequestError,
  } = useManagerApprovalLetterClientSignedPage();

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  if (isAmAccessLoading) {
    return <FullPageLoader />;
  }

  return (
    <ApplicationPageFrame
      modalAlert={modalAlert}
      modalSuccess={modalSuccess}
      onModalClose={isAmAccessDenied ? handleCloseAmAccessModal : handleCloseAlertModal}
      onSuccessModalClose={handleCloseSuccessModal}
    >
      <ApplicationHeader {...headerProps} />

      {isAmAccessDenied ? null : isApplicationLoading ? (
        <Box sx={commonStyles.centeredLoader}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={guaranteesClientPageStyles.applicationFlowStack}>
          <GuaranteesManagerApplicationSidePanelLayout
            applicationId={effectiveApplicationId}
            onError={showGuaranteesRequestError}
          >
            <ClientSignedApprovalLetterSection
              isDocumentLoading={isDocumentLoading}
              pdfUrl={pdfUrl}
              onOpenPdf={handleOpenPdf}
            />

            <Box sx={guaranteesClientPageStyles.flowPageActionsCentered}>
              <Button
                variant="contained"
                color="primary"
                type="button"
                sx={guaranteesClientPageStyles.generatedDocumentOpenButton}
                disabled={isSubmitDisabled}
                onClick={handleSubmitByAmManager}
                startIcon={isSubmittingByAmManager ? <ButtonLoadingIcon /> : undefined}
              >
                {MANAGER_APPROVAL_LETTER_TEXT.submitButton}
              </Button>
            </Box>
          </GuaranteesManagerApplicationSidePanelLayout>
        </Box>
      )}
    </ApplicationPageFrame>
  );
};

export default ManagerApprovalLetterClientSignedPage;
